import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Channels } from "constant";
import Icon from "module-common/Icon";

export default class ChannelLimit extends Component {
  static propTypes = {
    channel: PropTypes.string,
    limit: PropTypes.number
  };
  static defaultProps = {
    limit: 0
  };

  render() {
    const { channel, limit } = this.props;

    // decide channel icon
    let icon;
    const ch = this.getChannel(channel);
    if (ch) icon = ch.icon;

    return (
      <Wrapper>
        <Icon name={icon} />
        <Limit isMinus={limit < 0}>{limit}</Limit>
      </Wrapper>
    );
  }

  getChannel = channel => {
    for (const ch of Channels) {
      if (ch.name === channel) {
        return ch;
      }
    }
  };
}

const Wrapper = styled.div`
  display: flex;
  flex-directon: row;
  align-items: center;
`;
const Limit = styled.div`
  font-size: 0.8rem;
  margin-left: 5px;
  color: ${props => (props.isMinus ? "red" : props.theme.uiText)};
`;



// WEBPACK FOOTER //
// ./src/module-case-management/content-panel/footer/ChannelLimit.js